import React from 'react';
import { Card } from '../../ui/Card';
import { useStore } from '../../../store/useStore';
import { ListTodo, CheckCircle, Clock, AlertTriangle } from 'lucide-react';
import { motion } from 'framer-motion';

export const TaskOverview: React.FC = () => {
  const tasks = useStore((state) => state.tasks);
  
  const completedTasks = tasks.filter(task => task.status === 'COMPLETED');
  const pendingTasks = tasks.filter(task => task.status === 'PENDING');
  const inProgressTasks = tasks.filter(task => task.status === 'IN_PROGRESS');

  return (
    <Card className="p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="p-2 bg-emerald-100 rounded-lg">
          <ListTodo className="w-5 h-5 text-emerald-600" />
        </div>
        <h2 className="text-lg font-semibold">Task Overview</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="p-4 bg-blue-50 rounded-lg">
          <div className="flex items-center gap-2 mb-2">
            <Clock className="w-4 h-4 text-blue-600" />
            <span className="text-sm font-medium text-blue-700">Pending</span>
          </div>
          <p className="text-2xl font-bold text-blue-900">{pendingTasks.length}</p>
        </div>

        <div className="p-4 bg-amber-50 rounded-lg">
          <div className="flex items-center gap-2 mb-2">
            <ListTodo className="w-4 h-4 text-amber-600" />
            <span className="text-sm font-medium text-amber-700">In Progress</span>
          </div>
          <p className="text-2xl font-bold text-amber-900">{inProgressTasks.length}</p>
        </div>

        <div className="p-4 bg-emerald-50 rounded-lg">
          <div className="flex items-center gap-2 mb-2">
            <CheckCircle className="w-4 h-4 text-emerald-600" />
            <span className="text-sm font-medium text-emerald-700">Completed</span>
          </div>
          <p className="text-2xl font-bold text-emerald-900">{completedTasks.length}</p>
        </div>
      </div>
    </Card>
  );
};